import download from "./download.svg";

export default function DownloadIcon() {
  return (
    <img src={download} />
  );
}